import React, { useRef } from "react";
import { Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; 
import { GenderData } from "../../../../../../../data";
import { save } from "../../../../../../../features/save/saveSlice";
import toast from "react-hot-toast";

const { TextArea } = Input;
const ProductionVerifyModal = ({ isModalOpen, handleCancel, handleFetch,prodd1,data2 }) => {

  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { user } = useSelector((state) => state.auth);
  const { myUsersData } = useSelector((state) => state.fetch);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = async (data) => {
    let verified = data2 && data2?.find((item) => item?.prodCat === data?.prodCat); 
    const res = await dispatch(
      save({
        ...verified,
        url: `prod/approve_production_detail/${data?.prodComments}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };
 

  return (
    <>
      <Modal
        className="!w-[31.6875rem]"
        title={"Verify Production Data"}
        open={isModalOpen}
        onOk={onFinish}
        onCancel={handleCancel}
      >
        <div className="details_h">
          Verify that the data provided by the farmer and scheme manager are
          accurate and consistent?
        </div>
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className="mt-[2.69rem]"
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            name="prodCat"
            className=""
            label={"Verified Production"}
            rules={[
              {
                required: true,
                message: "Please select verified production",
              },
            ]}
          >
            <Select
              placeholder="Select"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                data2?.length > 0 &&
                data2?.map((item) => ({
                  value: item?.prodCat,
                  label: item?.prodCat,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>

          <Form.Item
            name="prodComments"
            label={"Comments"}
            rules={[
              {
                required: true,
                message: "Please add project comments",
              },
            ]}
          >
            <TextArea
              placeholder="Comments..."
              rows={5}
              className="text_area"
            />
          </Form.Item>

          <div className="flex justify-between mt-[1.75rem] ">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center  gap-x-5">
              <div className="w-[100px] ">
                <button
                  type="button"
                  key="back"
                  onClick={handleCancel}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[100px]">
                <button disabled={saving} key="submit" type="submit" className="cstm-btn-2">
                  {saving ? <Spin /> : "Update"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default ProductionVerifyModal;
